export default function () {
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-support-search-input]')) {
      const el = e.target;
      const val = el.value;
      const append = el.getAttribute('data-append');
      const query = `${val} ${append}`;

      const parent = el.parentElement.parentElement;
      const searchQueryElement = parent.querySelector('[data-search-query]');
      searchQueryElement.value = query;
    }
  });
}
